/**
 * Created by falknisius on 15.05.17.
 */
// ADD AND CHANGE STRINGS HERE
// ------------------------------------------------------------------------------------------------------------------

const STRINGS = {
  APP_TITLE: {
    de: 'Corporate Card Editor',
    en: 'Corporate Card Editor'
  },

  ERROR_HTTP_COMMUNICATION: {
    de: 'Netzwerk Kommunikation nicht efolgreich',
    en: 'communication error'
  },

  REGISTRATION_ERROR: {
    de: 'Registrierungsfehler',
    en: 'Registration Error'
  },

  LOGIN_ERROR: {
    de: 'Anmeldefehler',
    en: 'Login Error'
  },

  REGISTRATION_SUCCESS_TITLE: {
    de: 'Registrierung erfolgreich',
    en: 'Registrations succeed'
  },

  ERROR_ACTIVATIONCODE_EMPTY: {
    de: 'Die ERV Versicherungsnummer muss mit Länderkürzel und Nummer ausgefüllt werden.',
    en: 'The policy number must be inserted with country code and number.'
  },

  ERROR_INVALID_EMAIL: {
    de: 'Die Emailadresse scheint nicht korrekt zu sein.',
    en: 'The email address seems to be invalid.'
  },

  ERROR_PASSWORD_SHORT: {
    de: 'Das Passwort ist zu kurz.',
    en: 'The password is too short.'
  },

  ERROR_PASSWORD_POLICY: {
    de: 'Das Passwort entspricht nicht den Anforderungen (Groß-, Kleinbuchstaben, Ziffern, Sonderzeichen).',
    en: 'The password does\'nt match the requirements. (upper case, lower case letters, digits and special chars)'
  },

  ERROR_PASSWORD_NOTMATCH: {
    de: 'Die Passworte stimmen nicht überein.',
    en: 'The passwords doesn\'t match.'
  },

  'invalid inputs': {
    de: 'Es sind nicht alle Felder korrekt ausgefüllt.',
    en: 'There invalid inputs.'
  },

  REGISTRATION_SUCCESS_TEXT: {
    de: 'Sie haben sich erfoglreich registriert und können mit der Pflege der Corporate Card beginnen.',
    en: 'You have successfully registered and can start with the maintenance of the corporate card  descriptions.'
  },

  'code not found': {
    de: 'Diese ERV Versicherungsnummer ist nicht bekannt.',
    en: 'Policy number invalid.'
  },

  'user not found': {
    de: 'Nutzer ist nicht bekannt.',
    en: 'User not found.'
  },

  'code in use': {
    de: 'Diese ERV Versicherungsnummer wurde bereits zur Registrierung verwendet.',
    en: 'Policy number is already used.'
  },

  'nickname is used in this group': {
    de: 'Ein Nutzer mit dieser Email wurde bereits registriert.',
    en: 'There is already one User with this email registered.'
  },

  'Bad credentials': {
    de: 'Ungültige Zugangsdaten.',
    en: 'Invalid credentials.'
  },

  ERROR_HEADLINE: {
    de: 'Fehler',
    en: 'Error'
  },

  INSURANCE_DESCRIPTION: {
    de: 'Corporate Travel Information',
    en: 'Corporate Travel Information'
  },

  NO_DOCUMENTS: {
    de: 'Noch keine Dokumente hochgeladen.',
    en: 'No documents uploaded.'
  },

  ADD_DOCUMENT: {
    de: 'Dokument hinzufügen',
    en: 'Upload document'
  },

  EDIT_DOCUMENT: {
    de: 'Document bearbeiten',
    en: 'Update document'
  },

  DOCUMENT_TITLE: {
    de: 'Angezeigter Dateiname',
    en: 'Document title'
  },

  DOCUMENT_DESCRIPTION: {
    de: 'Dokumentenerläuterung',
    en: 'Document description'
  },

  UPLOAD_DOCUMENT: {
    de: 'Dokument hochladen',
    en: 'upload document'
  },

  TARIFF_VISIBLE_FROM_HELP: {
    de: 'Sie können das Datum auch mit der Tastatur eingeben.',
    en: 'You can also enter the date using the keyboard.'
  },

  CANCEL: {
    de: 'Abbrechen',
    en: 'Cancel'
  },

  OK: {
    de: 'Ok',
    en: 'Ok'
  },

  SAVE_DOCUMENT: {
    de: 'Speichern',
    en: 'Save'
  },

  UPDATE_DOCUMENT: {
    de: 'Aktualisieren',
    en: 'Update'
  },

  ACTIVATIONCODE: {
    de: 'ERV Versicherungsnummer',
    en: 'Policy number'
  },

  LOGIN: {
    de: 'Login',
    en: 'Login'
  },

  LOGOUT: {
    de: 'Logout',
    en: 'Logout'
  },

  EMAIL: {
    'de': 'E-Mail-Adresse',
    'en': 'email'
  },

  PASSWORD: {
    'de': 'Passwort',
    'en': 'password'
  },

  PASSWORD2: {
    'de': 'Passwort Wiederholung',
    'en': 'Repeat password'
  },

  REGISTER: {
    'de': 'Registrieren',
    'en': 'Register'
  },

  FORGOT_TITLE: {
    'de': 'Passwort vergessen',
    'en': 'Forgot password'
  },

  FORGOT_SEND: {
    'de': 'Passwort zurücksetzen',
    'en': 'Reset password'
  },

  BUTTON_SEND_NEXT: {
    de: 'Weitere Nachricht senden',
    en: 'send other feedback'
  },

  BUTTON_SEND_REPEAT: {
    de: 'Nachricht nocheinmal senden',
    en: 'try repeat send feedback'
  },

  RESET_PASSWORD_HEADLINE: {
    de: 'Passwort zurücksetzen',
    en: 'Reset password'
  },

  SAVE_PASSWORD: {
    de: 'Speichern',
    en: 'Save'
  },

  PASSWORD_RESET: {
    de: 'Neues Passwort eingeben',
    en: 'Insert new password'
  },

  RESET_ERROR: {
    de: 'Passwort ändern Fehler',
    en: 'Change password error'
  },

  RESET_SUCCESS_TEXT: {
    de: 'Sie haben Ihr Passwort erfolgreich geändert und können mit der Pflege der Corporate Card fortfahren.',
    en: 'You have successfully changed your password and can continue with the maintenance of the corporat card.'
  },

  RESET_SUCCESS_TITLE: {
    de: 'Passwortänderung erfolgreich',
    en: 'Password change succeed'
  },

  FORGOT_ERROR: {
    de: 'Passwort vergessen Fehler',
    en: 'Password forgot error'
  },

  FORGOT_SEND_SUCCESS: {
    de: 'Eine Nachricht mit Zurücksetzanweisungen wurde erfolgreich an "$0" verschickt. Sie haben $1 Minuten Zeit, den darin enthaltenen Link zu klicken und ein neues Passwort einzugeben.',
    en: 'A message with reset instructions was successfully sent to "$0". You have $1 minutes to click on the link in the message and enter a new password.'
  },

  CARD_TEXT_INIT: {
    de: 'Hier steht der einleitende Text zu Ihren Dokumenten.',
    en: 'Here is the introductory text to your documents.'
  },

  DELETE_DOCUMENT_HEADER: {
    de: 'Dokument löschen',
    en: 'Delete document'
  },

  DELETE_DOCUMENT_COPY: {
    de: 'Wollen Sie das Dokument "$0" wirklich unwiederuflich löschen?',
    en: 'Are you sure you want to permanently delete the document "$0"?'
  },

  SAVING_HINT: {
    de: 'Hinweis: Alle Änderungen sind sofort in der Corporate Kachel in der Travel and Care App sichtbar, wenn sie das nächste mal geöffnet wird.',
    en: 'Note: Any changes will be immediately visible in the corporate tile in the Travel and Care app when it is next opened.'
  },

  INTRODUCTION_HEADER: {
    de: 'Einleitung',
    en: 'Introduction'
  },

  DOCUMENTS_HEADER: {
    de: 'Dokumente',
    en: 'Documents'
  },

  SAVING_TEXT_MESSAGE: {
    de: 'Sichern der Textänderungen.',
    en: 'Save the text changes.'
  },

  SAVED_TEXT_MESSAGE: {
    de: '\u00A0',
    en: '\u00A0'
  }

}

// THIS IS SOURCE CODE BELOW THIS LINE
// ------------------------------------------------------------------------------------------------------------------

const applyArgsToString = (string, args) => {
  let stringWithAppliedArgs = string
  let i = 0
  args.forEach(arg => {
    stringWithAppliedArgs = stringWithAppliedArgs.replace(`$${i}`, arg)
    i += 1
  })
  return stringWithAppliedArgs
}

export let target = {
  supportedLanguages: ['de', 'en'],
  choosenLanguage: 'de'
}

/**
 * Returns the string for the requested key in the prefererred language.
 * If it is not found all languages of higher priority are checked (as specified in config or target config).
 * If not present there either the key itself will be returned
 *
 * If no preferred language is given, the first language as specified in config or target config is used.
 */
export default (key, args = [], preferredLanguage = target.choosenLanguage) => {
  // return 'key' if key does not exist
  if (!STRINGS[key]) {
    if (!args || args.length > 0) {
      return `${key} (${JSON.stringify(args)}`
    }
    return key
  }

  const strings = STRINGS[key] ? STRINGS[key] : {}

  // check if string exists in preferred language
  if (strings[preferredLanguage]) {
    return applyArgsToString(strings[preferredLanguage], args)
  }

  // find best language
  const bestAvailLanguage = target.supportedLanguages.filter(language => Object.keys(strings).indexOf(language) >= 0)
  return applyArgsToString(strings[bestAvailLanguage], args)
}
